function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Base } from "../shared/Base/Base.js";
import { Panzoom } from "../Panzoom/Panzoom.js";
import { extend } from "../shared/utils/extend.js";
import { round } from "../shared/utils/round.js";
import { throttle } from "../shared/utils/throttle.js";
import { Plugins } from "./plugins/index.js"; // Default language

import en from "./l10n/en.js";
var defaults = {
  // Virtual slides. Each object should have at least `html` property that will be used to set content,
  // example: `slides: [{html: 'First slide'}, {html: 'Second slide'}]`
  slides: [],
  // Number of slides to preload before/after visible slides
  preload: 0,
  // Number of slides to group into the page,
  // if `auto` - group all slides that fit into the viewport
  slidesPerPage: "auto",
  // Index of initial page
  initialPage: null,
  // Index of initial slide
  initialSlide: null,
  // Panzoom friction while changing page
  friction: 0.92,
  // Should center active page
  center: true,
  // Should carousel scroll infinitely
  infinite: true,
  // Should the gap be filled before first and after last slide if `infinite: false`
  fill: true,
  // Should Carousel settle at any position after a swipe.
  dragFree: false,
  // Prefix for CSS classes, must be the same as the  SCSS `$carousel-prefix` variable
  prefix: "",
  // Class names for DOM elements (without prefix)
  classNames: {
    viewport: "carousel__viewport",
    track: "carousel__track",
    slide: "carousel__slide",
    // Classname toggled for slides inside current page
    slideSelected: "is-selected"
  },
  // Localization of strings
  l10n: en
};
export var Carousel = /*#__PURE__*/function (_Base) {
  _inherits(Carousel, _Base);

  var _super = _createSuper(Carousel);

  /**
   * Carousel constructor
   * @constructs Carousel
   * @param {HTMLElement} $container - Carousel container
   * @param {Object} [options] - Options for Carousel
   */
  function Carousel($container) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Carousel);

    options = extend(true, {}, defaults, options);
    _this = _super.call(this, options);
    _this.state = "init";
    _this.$container = $container;

    if (!(_this.$container instanceof HTMLElement)) {
      throw new Error("No root element provided");
    }

    _this.slideNext = throttle(_this.slideNext.bind(_assertThisInitialized(_this)), 250, true);
    _this.slidePrev = throttle(_this.slidePrev.bind(_assertThisInitialized(_this)), 250, true);

    _this.init();

    return _this;
  }
  /**
   * Perform initialization
   */


  _createClass(Carousel, [{
    key: "init",
    value: function init() {
      this.pages = [];
      this.page = this.pageIndex = null;
      this.prevPage = this.prevPageIndex = null;
      this.attachPlugins(Carousel.Plugins);
      this.trigger("init");
      this.initLayout();
      this.initSlides();
      this.updateMetrics();

      if (this.$track && this.pages.length) {
        this.$track.style.transform = "translate3d(".concat(this.pages[this.page].left * -1, "px, 0px, 0) scale(1)");
      }

      this.manageSlideVisiblity();
      this.initPanzoom();
      this.state = "ready";
      this.trigger("ready");
    }
    /**
     * Initialize layout; create necessary elements
     */

  }, {
    key: "initLayout",
    value: function initLayout() {
      var prefix = this.option("prefix");
      var classNames = this.option("classNames");
      this.$viewport = this.option("viewport") || this.$container.querySelector(".".concat(prefix).concat(classNames.viewport));

      if (!this.$viewport) {
        var _this$$viewport;

        this.$viewport = document.createElement("div");
        this.$viewport.classList.add(prefix + classNames.viewport);

        (_this$$viewport = this.$viewport).append.apply(_this$$viewport, _toConsumableArray(this.$container.childNodes));

        this.$container.appendChild(this.$viewport);
      }

      this.$track = this.option("track") || this.$container.querySelector(".".concat(prefix).concat(classNames.track));

      if (!this.$track) {
        var _this$$track;

        this.$track = document.createElement("div");
        this.$track.classList.add(prefix + classNames.track);

        (_this$$track = this.$track).append.apply(_this$$track, _toConsumableArray(this.$viewport.childNodes));

        this.$viewport.appendChild(this.$track);
      }
    }
    /**
     * Fill `slides` array with objects from existing nodes and/or `slides` option
     */

  }, {
    key: "initSlides",
    value: function initSlides() {
      var _this2 = this;

      this.slides = []; // Get existing slides from the DOM

      var elems = this.$viewport.querySelectorAll(".".concat(this.option("prefix")).concat(this.option("classNames.slide")));
      elems.forEach(function (el) {
        var slide = {
          $el: el,
          isDom: true
        };

        _this2.slides.push(slide);

        _this2.trigger("createSlide", slide, _this2.slides.length);
      }); // Add virtual slides, but do not create DOM elements yet,
      // because they will be created dynamically based on current carousel position

      if (Array.isArray(this.options.slides)) {
        this.slides = extend(true, _toConsumableArray(this.slides), this.options.slides);
      }
    }
    /**
     * Do all calculations related to slide size and paging
     */

  }, {
    key: "updateMetrics",
    value: function updateMetrics() {
      var _this3 = this;

      // Calculate content width, viewport width
      // ===
      var contentWidth = 0;
      var indexes = [];
      var lastSlideWidth;
      this.slides.forEach(function (slide, index) {
        var $el = slide.$el;
        var slideWidth = slide.isDom || !lastSlideWidth ? _this3.getSlideMetrics($el) : lastSlideWidth;
        slide.index = index;
        slide.width = slideWidth;
        slide.left = contentWidth;
        lastSlideWidth = slideWidth;
        contentWidth += slideWidth;
        indexes.push(index);
      });
      var viewportWidth = Math.max(this.$track.offsetWidth, round(this.$track.getBoundingClientRect().width));
      var viewportStyles = getComputedStyle(this.$track);
      viewportWidth = viewportWidth - (parseFloat(viewportStyles.paddingLeft) + parseFloat(viewportStyles.paddingRight));
      this.contentWidth = contentWidth;
      this.viewportWidth = viewportWidth; // Split slides into pages
      // ===

      var pages = [];
      var slidesPerPage = this.option("slidesPerPage");

      if (Number.isInteger(slidesPerPage) && contentWidth > viewportWidth) {
        // Fixed number of slides in the page
        for (var i = 0; i < this.slides.length; i += slidesPerPage) {
          pages.push({
            indexes: indexes.slice(i, i + slidesPerPage),
            slides: this.slides.slice(i, i + slidesPerPage)
          });
        }
      } else {
        // Slides that fit inside viewport
        var currentPage = 0;
        var currentWidth = 0;

        for (var _i = 0; _i < this.slides.length; _i += 1) {
          var slide = this.slides[_i]; // Add next page

          if (!pages.length || currentWidth + slide.width > viewportWidth) {
            pages.push({
              indexes: [],
              slides: []
            });
            currentPage = pages.length - 1;
            currentWidth = 0;
          }

          currentWidth += slide.width;
          pages[currentPage].indexes.push(_i);
          pages[currentPage].slides.push(slide);
        }
      }

      var shouldCenter = this.option("center");
      var shouldFill = this.option("fill"); // Calculate width and start position for each page
      // ===

      pages.forEach(function (page, index) {
        page.index = index;
        page.width = page.slides.reduce(function (sum, slide) {
          return sum + slide.width;
        }, 0);
        page.left = page.slides[0].left;

        if (shouldCenter) {
          page.left += (viewportWidth - page.width) * 0.5 * -1;
        }

        if (shouldFill && !_this3.option("infiniteX", _this3.option("infinite")) && contentWidth > viewportWidth) {
          page.left = Math.max(page.left, 0);
          page.left = Math.min(page.left, contentWidth - viewportWidth);
        }
      }); // Merge pages
      // ===

      var rez = [];
      var prevPage;
      pages.forEach(function (page2) {
        var page = _objectSpread({}, page2);

        if (prevPage && page.left === prevPage.left) {
          prevPage.width += page.width;
          prevPage.slides = [].concat(_toConsumableArray(prevPage.slides), _toConsumableArray(page.slides));
          prevPage.indexes = [].concat(_toConsumableArray(prevPage.indexes), _toConsumableArray(page.indexes));
        } else {
          page.index = rez.length;
          prevPage = page;
          rez.push(page);
        }
      });
      this.pages = rez;
      var page = this.page;

      if (page === null) {
        var initialSlide = this.option("initialSlide");

        if (initialSlide !== null) {
          page = this.findPageForSlide(initialSlide);
        } else {
          page = this.option("initialPage", 0);
        }

        if (!rez[page]) {
          page = rez.length && page > rez.length ? rez[rez.length - 1].index : 0;
        }

        this.page = page;
        this.pageIndex = page;
      }

      this.updatePanzoom();
      this.trigger("refresh");
    }
    /**
     * Calculate slide element width (including left, right margins)
     * @param {Object} node
     * @returns {Number} Width in px
     */

  }, {
    key: "getSlideMetrics",
    value: function getSlideMetrics(node) {
      if (!node) {
        var firstSlide = this.slides[0];
        node = document.createElement("div");
        node.dataset.isTestEl = 1;
        node.style.visibility = "hidden";
        node.classList.add(this.option("prefix") + this.option("classNames.slide")); // Assume all slides have the same custom class, if any

        if (firstSlide.customClass) {
          var _node$classList;

          (_node$classList = node.classList).add.apply(_node$classList, _toConsumableArray(firstSlide.customClass.split(" ")));
        }

        this.$track.prepend(node);
      }

      var width = Math.max(node.offsetWidth, round(node.getBoundingClientRect().width)); // Add left/right margin

      var style = node.currentStyle || window.getComputedStyle(node);
      width = width + (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);

      if (node.dataset.isTestEl) {
        node.remove();
      }

      return width;
    }
    /**
     *
     * @param {Integer} index Index of the slide
     * @returns {Integer|null} Index of the page if found, or null
     */

  }, {
    key: "findPageForSlide",
    value: function findPageForSlide(index) {
      var page = this.pages.find(function (page) {
        return page.indexes.indexOf(index) > -1;
      });
      return page ? page.index : null;
    }
    /**
     * Slide to next page, if possible
     */

  }, {
    key: "slideNext",
    value: function slideNext() {
      this.slideTo(this.pageIndex + 1);
    }
    /**
     * Slide to previous page, if possible
     */

  }, {
    key: "slidePrev",
    value: function slidePrev() {
      this.slideTo(this.pageIndex - 1);
    }
    /**
     * Slides carousel to given page
     * @param {Number} page - New index of active page
     * @param {Object} [params] - Additional options
     */

  }, {
    key: "slideTo",
    value: function slideTo(page) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _params$x = params.x,
          x = _params$x === void 0 ? this.setPage(page, true) * -1 : _params$x,
          _params$y = params.y,
          y = _params$y === void 0 ? 0 : _params$y,
          _params$friction = params.friction,
          friction = _params$friction === void 0 ? this.option("friction") : _params$friction;

      if (this.Panzoom.content.x === x && !this.Panzoom.velocity.x && friction) {
        return;
      }

      this.Panzoom.panTo({
        x: x,
        y: y,
        friction: friction,
        ignoreBounds: true
      });

      if (this.state === "ready" && this.Panzoom.state === "ready") {
        this.trigger("settle");
      }
    }
    /**
     * Initialise main Panzoom instance
     */

  }, {
    key: "initPanzoom",
    value: function initPanzoom() {
      var _this4 = this;

      if (this.Panzoom) {
        this.Panzoom.destroy();
      } // Create fresh object containing options for Pazoom instance


      var options = extend(true, {}, {
        // Track element will be set as Panzoom $content
        content: this.$track,
        wrapInner: false,
        resizeParent: false,
        // Disable any user interaction
        zoom: false,
        click: false,
        // Right now, only horizontal navigation is supported
        lockAxis: "x",
        x: this.pages.length ? this.pages[this.page].left * -1 : 0,
        centerOnStart: false,
        // Make `textSelection` option more easy to customize
        textSelection: function textSelection() {
          return _this4.option("textSelection", false);
        },
        // Disable dragging if content (e.g. all slides) fits inside viewport
        panOnlyZoomed: function panOnlyZoomed() {
          return this.content.width <= this.viewport.width;
        }
      }, this.option("Panzoom")); // Create new Panzoom instance

      this.Panzoom = new Panzoom(this.$container, options);
      this.Panzoom.on({
        // Bubble events
        "*": function _(name) {
          for (var _len = arguments.length, details = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            details[_key - 1] = arguments[_key];
          }

          return _this4.trigger.apply(_this4, ["Panzoom.".concat(name)].concat(details));
        },
        // The rest of events to be processed
        afterUpdate: function afterUpdate() {
          _this4.updatePage();
        },
        beforeTransform: this.onBeforeTransform.bind(this),
        touchEnd: this.onTouchEnd.bind(this),
        endAnimation: function endAnimation() {
          _this4.trigger("settle");
        }
      }); // The contents of the slides may cause the page scroll bar to appear, so the carousel width may change
      // and slides have to be repositioned

      this.updateMetrics();
      this.manageSlideVisiblity();
    }
  }, {
    key: "updatePanzoom",
    value: function updatePanzoom() {
      if (!this.Panzoom) {
        return;
      }

      this.Panzoom.content = _objectSpread(_objectSpread({}, this.Panzoom.content), {}, {
        fitWidth: this.contentWidth,
        origWidth: this.contentWidth,
        width: this.contentWidth
      });

      if (this.pages.length > 1 && this.option("infiniteX", this.option("infinite"))) {
        this.Panzoom.boundX = null;
      } else if (this.pages.length) {
        this.Panzoom.boundX = {
          from: this.pages[this.pages.length - 1].left * -1,
          to: this.pages[0].left * -1
        };
      }

      if (this.option("infiniteY", this.option("infinite"))) {
        this.Panzoom.boundY = null;
      } else {
        this.Panzoom.boundY = {
          from: 0,
          to: 0
        };
      }

      this.Panzoom.handleCursor();
    }
  }, {
    key: "manageSlideVisiblity",
    value: function manageSlideVisiblity() {
      var _this5 = this;

      var contentWidth = this.contentWidth;
      var viewportWidth = this.viewportWidth;
      var currentX = this.Panzoom ? this.Panzoom.content.x * -1 : this.pages.length ? this.pages[this.page].left : 0;
      var preload = this.option("preload");
      var infinite = this.option("infiniteX", this.option("infinite"));
      var paddingLeft = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-left"));
      var paddingRight = parseFloat(getComputedStyle(this.$viewport, null).getPropertyValue("padding-right")); // Check visibility of each slide

      this.slides.forEach(function (slide) {
        var leftBoundary, rightBoundary;
        var hasDiff = 0; // #1 - slides in current viewport; this does not include infinite items

        leftBoundary = currentX - paddingLeft;
        rightBoundary = currentX + viewportWidth + paddingRight;
        leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
        rightBoundary += preload * (viewportWidth + paddingLeft + paddingRight);
        var insideCurrentInterval = slide.left + slide.width > leftBoundary && slide.left < rightBoundary; // #2 - infinite items inside current viewport; from previous interval

        leftBoundary = currentX + contentWidth - paddingLeft;
        rightBoundary = currentX + contentWidth + viewportWidth + paddingRight; // Include slides that have to be preloaded

        leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
        var insidePrevInterval = infinite && slide.left + slide.width > leftBoundary && slide.left < rightBoundary; // #2 - infinite items inside current viewport; from next interval

        leftBoundary = currentX - contentWidth - paddingLeft;
        rightBoundary = currentX - contentWidth + viewportWidth + paddingRight; // Include slides that have to be preloaded

        leftBoundary -= preload * (viewportWidth + paddingLeft + paddingRight);
        var insideNextInterval = infinite && slide.left + slide.width > leftBoundary && slide.left < rightBoundary; // Create virtual slides that should be visible or preloaded, remove others

        if (insidePrevInterval || insideCurrentInterval || insideNextInterval) {
          _this5.createSlideEl(slide);

          if (insideCurrentInterval) {
            hasDiff = 0;
          }

          if (insidePrevInterval) {
            hasDiff = -1;
          }

          if (insideNextInterval) {
            hasDiff = 1;
          } // Bring preloaded slides back to viewport, if needed


          if (slide.left + slide.width > currentX && slide.left <= currentX + viewportWidth + paddingRight) {
            hasDiff = 0;
          }
        } else {
          _this5.removeSlideEl(slide);
        }

        slide.hasDiff = hasDiff;
      }); // Reposition slides for continuity

      var nextIndex = 0;
      var nextPos = 0;
      this.slides.forEach(function (slide, index) {
        var updatedX = 0;

        if (slide.$el) {
          if (index !== nextIndex || slide.hasDiff) {
            updatedX = nextPos + slide.hasDiff * contentWidth;
          } else {
            nextPos = 0;
          }

          slide.$el.style.left = Math.abs(updatedX) > 0.1 ? "".concat(nextPos + slide.hasDiff * contentWidth, "px") : "";
          nextIndex++;
        } else {
          nextPos += slide.width;
        }
      });
      this.markSelectedSlides();
    }
    /**
     * Creates main DOM element for virtual slides,
     * lazy loads images inside regular slides
     * @param {Object} slide
     */

  }, {
    key: "createSlideEl",
    value: function createSlideEl(slide) {
      if (!slide) {
        return;
      }

      if (slide.$el) {
        var curentIndex = parseInt(slide.$el.dataset.index, 10);

        if (curentIndex !== slide.index) {
          slide.$el.dataset.index = slide.index; // Lazy load images

          var $lazyNodes = slide.$el.querySelectorAll("[data-lazy-src]");
          $lazyNodes.forEach(function (node) {
            var lazySrc = node.dataset.lazySrc;

            if (node instanceof HTMLImageElement) {
              node.src = lazySrc;
            } else {
              node.style.backgroundImage = "url('".concat(lazySrc, "')");
            }
          });
          var lazySrc;

          if (lazySrc = slide.$el.dataset.lazySrc) {
            slide.$el.style.backgroundImage = "url('".concat(lazySrc, "')");
          }

          slide.state = "ready";
        }

        return;
      }

      var div = document.createElement("div");
      div.dataset.index = slide.index;
      div.classList.add(this.option("prefix") + this.option("classNames.slide"));

      if (slide.customClass) {
        var _div$classList;

        (_div$classList = div.classList).add.apply(_div$classList, _toConsumableArray(slide.customClass.split(" ")));
      }

      if (slide.html) {
        div.innerHTML = slide.html;
      }

      var allElelements = [];
      this.slides.forEach(function (slide, index) {
        if (slide.$el) {
          allElelements.push(index);
        }
      }); // Find a place in DOM to insert an element

      var goal = slide.index;
      var refSlide = null;

      if (allElelements.length) {
        var refIndex = allElelements.reduce(function (prev, curr) {
          return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
        });
        refSlide = this.slides[refIndex];
      }

      this.$track.insertBefore(div, refSlide && refSlide.$el ? refSlide.index < slide.index ? refSlide.$el.nextSibling : refSlide.$el : null);
      slide.$el = div;
      this.trigger("createSlide", slide, goal);
      return slide;
    }
    /**
     * Removes main DOM element of given slide
     * @param {Object} slide
     */

  }, {
    key: "removeSlideEl",
    value: function removeSlideEl(slide) {
      if (slide.$el && !slide.isDom) {
        this.trigger("removeSlide", slide);
        slide.$el.remove();
        slide.$el = null;
      }
    }
    /**
     * Toggles selected class name and aria-hidden attribute for slides based on visibility
     */

  }, {
    key: "markSelectedSlides",
    value: function markSelectedSlides() {
      var _this6 = this;

      var selectedClass = this.option("classNames.slideSelected");
      var attr = "aria-hidden";
      this.slides.forEach(function (slide, index) {
        var $el = slide.$el;

        if (!$el) {
          return;
        }

        var page = _this6.pages[_this6.page];

        if (page && page.indexes && page.indexes.indexOf(index) > -1) {
          if (selectedClass && !$el.classList.contains(selectedClass)) {
            $el.classList.add(selectedClass);

            _this6.trigger("selectSlide", slide);
          }

          $el.removeAttribute(attr);
        } else {
          if (selectedClass && $el.classList.contains(selectedClass)) {
            $el.classList.remove(selectedClass);

            _this6.trigger("unselectSlide", slide);
          }

          $el.setAttribute(attr, true);
        }
      });
    }
    /**
     * Perform all calculations and center current page
     */

  }, {
    key: "updatePage",
    value: function updatePage() {
      this.updateMetrics();
      this.slideTo(this.page, {
        friction: 0
      });
    }
    /**
     * Process `Panzoom.beforeTransform` event to remove slides moved out of viewport and
     * to create necessary ones
     */

  }, {
    key: "onBeforeTransform",
    value: function onBeforeTransform() {
      if (this.option("infiniteX", this.option("infinite"))) {
        this.manageInfiniteTrack();
      }

      this.manageSlideVisiblity();
    }
    /**
     * Seamlessly flip position of infinite carousel, if needed; this way x position stays low
     */

  }, {
    key: "manageInfiniteTrack",
    value: function manageInfiniteTrack() {
      var contentWidth = this.contentWidth;
      var viewportWidth = this.viewportWidth;

      if (!this.option("infiniteX", this.option("infinite")) || this.pages.length < 2 || contentWidth < viewportWidth) {
        return;
      }

      var panzoom = this.Panzoom;
      var isFlipped = false;

      if (panzoom.content.x < (contentWidth - viewportWidth) * -1) {
        panzoom.content.x += contentWidth;
        this.pageIndex = this.pageIndex - this.pages.length;
        isFlipped = true;
      }

      if (panzoom.content.x > viewportWidth) {
        panzoom.content.x -= contentWidth;
        this.pageIndex = this.pageIndex + this.pages.length;
        isFlipped = true;
      }

      if (isFlipped && panzoom.state === "pointerdown") {
        panzoom.resetDragPosition();
      }

      return isFlipped;
    }
    /**
     * Process `Panzoom.touchEnd` event; slide to next/prev page if needed
     * @param {object} panzoom
     */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(panzoom, event) {
      var dragFree = this.option("dragFree"); // If this is a quick horizontal flick, slide to next/prev slide

      if (!dragFree && this.pages.length > 1 && panzoom.dragOffset.time < 350 && Math.abs(panzoom.dragOffset.y) < 1 && Math.abs(panzoom.dragOffset.x) > 5) {
        this[panzoom.dragOffset.x < 0 ? "slideNext" : "slidePrev"]();
        return;
      } // Set the slide at the end of the animation as the current one,
      // or slide to closest page


      if (dragFree) {
        var _this$getPageFromPosi = this.getPageFromPosition(panzoom.transform.x * -1),
            _this$getPageFromPosi2 = _slicedToArray(_this$getPageFromPosi, 2),
            nextPageIndex = _this$getPageFromPosi2[1];

        this.setPage(nextPageIndex);
      } else {
        this.slideToClosest();
      }
    }
    /**
     * Slides to the closest page (useful, if carousel is changed manually)
     * @param {Object} [params] - Object containing additional options
     */

  }, {
    key: "slideToClosest",
    value: function slideToClosest() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _this$getPageFromPosi3 = this.getPageFromPosition(this.Panzoom.content.x * -1),
          _this$getPageFromPosi4 = _slicedToArray(_this$getPageFromPosi3, 2),
          nextPageIndex = _this$getPageFromPosi4[1];

      this.slideTo(nextPageIndex, params);
    }
    /**
     * Returns index of closest page to given x position
     * @param {Number} xPos
     */

  }, {
    key: "getPageFromPosition",
    value: function getPageFromPosition(xPos) {
      var pageCount = this.pages.length;
      var center = this.option("center");

      if (center) {
        xPos += this.viewportWidth * 0.5;
      }

      var interval = Math.floor(xPos / this.contentWidth);
      xPos -= interval * this.contentWidth;
      var slide = this.slides.find(function (slide) {
        return slide.left <= xPos && slide.left + slide.width > xPos;
      });

      if (slide) {
        var pageIndex = this.findPageForSlide(slide.index);
        return [pageIndex, pageIndex + interval * pageCount];
      }

      return [0, 0];
    }
    /**
     * Changes active page
     * @param {Number} page - New index of active page
     * @param {Boolean} toClosest - to closest page based on scroll distance (for infinite navigation)
     */

  }, {
    key: "setPage",
    value: function setPage(page, toClosest) {
      var nextPosition = 0;
      var pageIndex = parseInt(page, 10) || 0;
      var prevPage = this.page,
          prevPageIndex = this.pageIndex,
          pageCount = this.pages.length;
      var contentWidth = this.contentWidth;
      var viewportWidth = this.viewportWidth;
      page = (pageIndex % pageCount + pageCount) % pageCount;

      if (this.option("infiniteX", this.option("infinite")) && contentWidth > viewportWidth) {
        var nextInterval = Math.floor(pageIndex / pageCount) || 0,
            elemDimWidth = contentWidth;
        nextPosition = this.pages[page].left + nextInterval * elemDimWidth;

        if (toClosest === true && pageCount > 2) {
          var currPosition = this.Panzoom.content.x * -1; // * Find closest interval

          var decreasedPosition = nextPosition - elemDimWidth,
              increasedPosition = nextPosition + elemDimWidth,
              diff1 = Math.abs(currPosition - nextPosition),
              diff2 = Math.abs(currPosition - decreasedPosition),
              diff3 = Math.abs(currPosition - increasedPosition);

          if (diff3 < diff1 && diff3 <= diff2) {
            nextPosition = increasedPosition;
            pageIndex += pageCount;
          } else if (diff2 < diff1 && diff2 < diff3) {
            nextPosition = decreasedPosition;
            pageIndex -= pageCount;
          }
        }
      } else {
        page = pageIndex = Math.max(0, Math.min(pageIndex, pageCount - 1));
        nextPosition = this.pages.length ? this.pages[page].left : 0;
      }

      this.page = page;
      this.pageIndex = pageIndex;

      if (prevPage !== null && page !== prevPage) {
        this.prevPage = prevPage;
        this.prevPageIndex = prevPageIndex;
        this.trigger("change", page, prevPage);
      }

      return nextPosition;
    }
    /**
     * Clean up
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this7 = this;

      this.state = "destroy";
      this.slides.forEach(function (slide) {
        _this7.removeSlideEl(slide);
      });
      this.slides = [];
      this.Panzoom.destroy();
      this.detachPlugins();
    }
  }]);

  return Carousel;
}(Base); // Expose version

Carousel.version = "__VERSION__"; // Static properties are a recent addition that dont work in all browsers yet

Carousel.Plugins = Plugins;